import * as React from 'react'
import * as moment from 'moment'
import ImageView from '../../ui/ImageView'
import ContextMenu from '../../ui/ContextMenu'
import { Route, Link } from 'react-router-dom'
import Edit from '../../icons/ui/Edit'
import { IActiveTripResponseV2, ISimpleProviderProduct } from '../../../types'
import { mapViewStrategyStages } from '../../MapView'
import { convertCentsToDollars } from '../../../utils'
import UIMessages from '../../../utils/ui-messages'
import Taxi from '../../icons/trips/Taxi'
import EditTripModal from '../../../containers/trips/EditTripModal'
import ExpandIcon from '../../icons/ui/ExpandIcon'
import CollapseIcon from '../../icons/ui/CollapseIcon'
import ReactTooltip from 'react-tooltip'
import { providerProductService } from '../../../services/ProviderProduct'
import { ITripGroupRides } from 'src/types/trip-group-rides'
import TripPaymentDisplay from './TripRiderDetails'
export interface ITripScheduledProps {
  currentTrip: IActiveTripResponseV2
  cloneTrip: (trip: IActiveTripResponseV2) => void
  createTrip: (riderId: string) => void
  cancelTrip: () => void
  getTripById: (tripId: string) => void
  setCurrentTripStage: (stage: string) => void
}

export interface ITripScheduledState {
  isDisplayAddOns: boolean
  estimatedLoadingTime: number
}
class TripScheduled extends React.Component<ITripScheduledProps, ITripScheduledState> {
  private static INTERVAL = 60000

  public state = {
    isDisplayAddOns: false,
    estimatedLoadingTime: 0
  }

  private tripTimerId: ReturnType<typeof setInterval>

  constructor(props: ITripScheduledProps) {
    super(props)
    this.EditDetails = this.EditDetails.bind(this)
  }

  public componentDidMount() {
    this.tripTimerId = setInterval(this.refreshTrip, TripScheduled.INTERVAL)
    this.props.setCurrentTripStage(mapViewStrategyStages.showPolyline)

    const { currentTrip } = this.props

    if (currentTrip.product.productId && this.state.estimatedLoadingTime === 0) {
      providerProductService.fetchOne(currentTrip.product.productId).then((product: ISimpleProviderProduct) => {
        this.setState({
          estimatedLoadingTime: product.estimatedLoadingTime ? product.estimatedLoadingTime : 0
        })
      })
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<ITripScheduledProps>,
    prevState: Readonly<ITripScheduledState>,
    snapshot?: any
  ): void {
    const { currentTrip } = this.props

    const prevProductId = prevProps.currentTrip.product.productId

    if (
      prevProductId &&
      currentTrip.product.productId &&
      prevProductId !== currentTrip.product.productId &&
      this.state.estimatedLoadingTime === 0
    ) {
      providerProductService.fetchOne(currentTrip.product.productId).then((product: ISimpleProviderProduct) => {
        this.setState({
          estimatedLoadingTime: product.estimatedLoadingTime ? product.estimatedLoadingTime : 0
        })
      })
    }
  }

  public componentWillUnmount() {
    clearInterval(this.tripTimerId)
  }

  public render() {
    const { currentTrip } = this.props
    const { riderCount, tripType } = currentTrip
    const { allottedTimeAtPickup = 0, allottedTimeAtDropoff = 0 } = currentTrip.product || {}
    const price = currentTrip.estimatedPrice ? `$${convertCentsToDollars(currentTrip.estimatedPrice)}` : 'Unavailable'
    const fare = currentTrip.estimatedFare ? `$${convertCentsToDollars(currentTrip.estimatedFare)}` : 'Unavailable'
    const assignedDriverName = currentTrip.operator
      ? `${currentTrip.operator.firstName} ${currentTrip.operator.lastName}`
      : 'N/A'

    //times are null if pickup and dropoff location are the same. only happens when booking test trips
    const pickupTime = currentTrip.scheduledPickupTime
      ? moment(currentTrip.scheduledPickupTime).format('M/D/YYYY hh:mmA')
      : 'No estimate available'
    const dropoffTime = currentTrip.scheduledDropoffTime
      ? moment(currentTrip.scheduledDropoffTime).format('M/D/YYYY hh:mmA')
      : 'No estimate available'
    let pickupQualifier
    let dropoffQualifier

    if (currentTrip.scheduleType === 'arrive_by') {
      pickupQualifier = 'Estimated'
      dropoffQualifier = 'Requested'
    } else if (currentTrip.scheduleType === 'leave_by') {
      pickupQualifier = 'Requested'
      dropoffQualifier = 'Estimated'
    } else {
      pickupQualifier = 'Estimated'
      dropoffQualifier = 'Estimated'
    }

    const operatorName = currentTrip.operator
      ? `${currentTrip.operator.firstName} ${currentTrip.operator.lastName}`
      : 'No operator assigned'
    const operatorPhone = currentTrip.operator ? currentTrip.operator.phone : ''
    const addOnKeyId = `${currentTrip.service.name}-${currentTrip.product.name}-add-on-key`.split(' ').join('_')

    const paymentMode =
      currentTrip.tripsGroupRides[0] && currentTrip.tripsGroupRides[0].fareType
        ? currentTrip.tripsGroupRides[0].fareType
        : 'Cash'

    return (
      <React.Fragment>
        <Route exact={true} path={`/trips/${currentTrip.id}/edit-details`} render={this.EditDetails} />
        <div className='px2 py2'>
          <div className='flex '>
            <ImageView
              entityId={currentTrip.operator ? currentTrip.operator.id : undefined}
              width='40px'
              height='40px'
            />
            <div className='col-10 pl2'>
              <div className='flex'>
                <p className='m0 font-black'>{operatorName}</p>
              </div>
              <div className='h6 font-grey2'>
                {currentTrip.service.name} {currentTrip.product.name}
              </div>
            </div>
            <div className='pl2 pt1'>
              <ContextMenu>
                <Link to={`/trips/${currentTrip.id}/assign-operator`}>
                  <Edit className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>{UIMessages.trip.assign}</span>
                </Link>
                <br />
                <Link to={`/trips/${currentTrip.id}/edit-details`}>
                  <Edit className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>{UIMessages.common.editDetails}</span>
                </Link>
              </ContextMenu>
            </div>
          </div>
          <div className='h6 font-grey2 pl1 mt1'>
            <span className='h6 font-black mr1'>Notes:</span>
            {currentTrip.notes}
          </div>
          <div className={'pl2 pt1 flex flex-wrap items-start bwidth1 bt-light-grey'}>
            <div className='flex flex-wrap items-center col-12'>
              <Taxi className='icon' />
              <div className='flex col-11'>
                <p className='font-dark-grey h6 weight-500 ml1'>{currentTrip.product.name}</p>
                <p className='font-grey2 h6 weight-500 ml-auto'>
                  {UIMessages.common.price}: {price}
                </p>
                <p className='font-grey2 h6 weight-500 ml2 mr2'>
                  {UIMessages.common.fare}: {fare}
                </p>
                {currentTrip.addOn && (
                  <div className='col-1 flex flex-row items-center ml2'>
                    {this.state.isDisplayAddOns ? (
                      <CollapseIcon className='icon--32x32' onClick={this.displayProductAddOns} />
                    ) : (
                      <ExpandIcon className='icon--32x32' onClick={this.displayProductAddOns} />
                    )}
                  </div>
                )}
              </div>
              {this.state.isDisplayAddOns && currentTrip.addOn && (
                <div>
                  <label className='font-grey2 h5'>Add ons:</label>
                  {Object.keys(currentTrip.addOn).map(key => {
                    return (
                      <div className='flex col-12 justify-start' id={addOnKeyId} key={key}>
                        <label className='font-grey2 h6 weight-300 ml2'>
                          {key} ${currentTrip.addOn && (currentTrip.addOn[key] / 100).toFixed(2)}
                        </label>
                      </div>
                    )
                  })}
                </div>
              )}
              <div className='flex col-11'>
                <p className='font-dark-grey h6 weight-500 mr1'>Driver assigned:</p>
                <p className='font-grey2 h6 weight-500'>{assignedDriverName}</p>
              </div>

              <div style={{ width: '100%' }}>
                <TripPaymentDisplay
                  tripsGroupRides={currentTrip.tripsGroupRides}
                  paymentMode={paymentMode}
                  {...tripType === 'import' && { riderCount }}
                  serviceId={currentTrip.service.serviceId}
                  tripId={currentTrip.id}
                  operatorId={
                    currentTrip.operator && currentTrip.operator.operatorId ? currentTrip.operator.operatorId : ''
                  }
                />
              </div>

              <div className='flex col-12 column-gap-16'>
                <div className='col-6'>
                  <p className='underline font-dark-grey h6 weight-500'>{'Allotted Time at Pickup'}</p>
                  <p className='bold font-black h6'>{`${allottedTimeAtPickup} ${
                    Number(allottedTimeAtPickup) <= 1 ? 'minute' : 'minutes'
                  }`}</p>
                </div>
                <div className='col-6'>
                  <p className='underline font-dark-grey h6 weight-500'>{'Allotted Time at Drop-off'}</p>
                  <p className='bold font-black h6'>{`${allottedTimeAtDropoff} ${
                    Number(allottedTimeAtDropoff) <= 1 ? 'minute' : 'minutes'
                  }`}</p>
                </div>
              </div>

              <div className='flex col-12 pt1 pb1 ml-auto'>
                <ReactTooltip
                  id='allottedloadingtime'
                  aria-haspopup='true'
                  globalEventOff='click'
                  effect='solid'
                  place='top'
                  className='shadow'
                  delayHide={200}
                  delayUpdate={200}
                  backgroundColor='#fff'
                />
                <div>
                  <p
                    className='underline font-dark-grey h6 weight-500 ml-auto mb0 mr2'
                    title={'Allotted Loading Time is ' + this.state.estimatedLoadingTime + ' minutes'}
                  >
                    {pickupQualifier} pickup{' '}
                    <button
                      style={{
                        fontSize: '10.70px',
                        borderStyle: 'none',
                        textDecorationColor: '#d9d9d9',
                        borderRadius: '65%',
                        cursor: 'pointer',
                        backgroundColor: '#d9d9d9'
                      }}
                      type='button'
                      className=''
                    >
                      <b style={{ color: '' }}>i</b>
                    </button>
                  </p>
                  <p className='bold font-black h6 ml-auto mt1 mr2'>{pickupTime}</p>
                </div>
                <div>
                  <p
                    className='underline font-dark-grey h6 weight-500 ml-auto mb0 mr2'
                    title={'Allotted Loading Time is ' + this.state.estimatedLoadingTime + ' minutes'}
                  >
                    {dropoffQualifier} dropoff{' '}
                    <button
                      style={{
                        fontSize: '10.70px',
                        borderStyle: 'none',
                        textDecorationColor: '#d9d9d9',
                        borderRadius: '65%',
                        cursor: 'pointer',
                        backgroundColor: '#d9d9d9'
                      }}
                      type='button'
                      className=''
                    >
                      <b style={{ color: '' }}>i</b>
                    </button>
                  </p>
                  <p className='bold font-black h6 ml-auto mt1 mr2'>{dropoffTime}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
  private EditDetails = (props: any) => {
    return (
      <EditTripModal
        createTrip={this.props.createTrip}
        cloneTrip={this.props.cloneTrip}
        cancelTrip={this.props.cancelTrip}
        currentTrip={this.props.currentTrip}
        enableOtherFields={true}
        {...props}
      />
    )
  }

  private displayProductAddOns = () => {
    this.setState({
      isDisplayAddOns: !this.state.isDisplayAddOns
    })
  }

  private refreshTrip = () => {
    this.props.getTripById(this.props.currentTrip.id)
  }
}

export default TripScheduled



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripScheduled.tsx